<template>
  <section class="appointSeviceDiv">
    <viewTitle
      title="业务管理 / 车辆预约管理 / 预约业务管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button type="primary" @click="modifyTpl('', 'add')" size="small"
          >新建预约业务</el-button
        >
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">父业务: </span>
        <el-select
          class="ctl"
          clearable
          v-model="params.pId"
          placeholder="请选择父业务"
          @change="changeSelectPID"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="item in parentSelectOption"
            :key="item.id"
          ></el-option>
        </el-select>
        <span class="rectl">状态: </span>
        <el-select
          class="ctl"
          clearable
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
          >刷新数据</el-button
        >
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="业务级别">
          <template slot-scope="scope">
            {{ scope.row.pid === "" ? "一级" : "二级" }}
          </template>
        </el-table-column>
        <el-table-column label="父业务">
          <template slot-scope="scope">
            {{ scope.row.pid === "" ? "--" : scope.row.p_name }}
          </template>
        </el-table-column>
        <el-table-column label="业务名称">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.note || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-else-if="scope.row.state === 2" class="color67">
              已禁用
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    @click.native.stop="modifyTpl(scope.row, 'edit')"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'forbid')"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'start')"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          :class="dialogParams.type === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.type === 'del' ? 'danger' : 'primary'"
          size="small"
          @click="confirm"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      v-if="isCreatAddElDialog"
      :visible.sync="dialogParams.showModify"
      width="43%"
      :close-on-click-modal="false"
      :title="
        dialogParams.typeModify === 'add' ? '新建预约业务' : '编辑预约业务'
      "
    >
      <div>
        <el-form label-width="140px">
          <el-form-item
            label="父业务"
            :rules="[{ required: true, message: '' }]"
          >
            <el-select
              v-model="modifyParams.parent"
              placeholder="请选择父业务"
              @change="changeEditParent"
              style="width: 100%;"
              :disabled="dialogParams.typeModify === 'edit'"
            >
              <el-option
                v-for="(item, index) in parentEditOption"
                :key="index"
                :label="item.name"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="业务名称"
            :rules="[{ required: true, message: '' }]"
          >
            <el-input
              v-model="modifyParams.name"
              placeholder="请输入业务名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="modifyParams.remark"
              placeholder="请输入备注（50字符以内）"
              rows="4"
            ></el-input>
          </el-form-item>
          <!-- 一级 父业务-->
          <div v-if="modifyParams.formType === -1">
            <el-form-item
              label="选择模板"
              :rules="[{ required: true, message: '' }]"
            >
              <el-radio-group v-model="modifyParams.tpl">
                <!-- <el-radio
                  :label="2"
                  v-if="
                    (modifyParams.tpl === 2 &&
                      dialogParams.typeModify === 'edit') ||
                      dialogParams.typeModify === 'add'
                  "
                  >卸货类(过地磅)</el-radio
                > -->
                <el-radio
                  :label="1"
                  v-if="
                    (modifyParams.tpl === 1 &&
                      dialogParams.typeModify === 'edit') ||
                      dialogParams.typeModify === 'add'
                  "
                  >成品出厂</el-radio
                >
                <el-radio
                  :label="0"
                  v-if="
                    (modifyParams.tpl === 0 &&
                      dialogParams.typeModify === 'edit') ||
                      dialogParams.typeModify === 'add'
                  "
                  >自定义业务</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    启用地磅后此业务下的数据会自动对接到地磅系统。
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span style="color: red;">*</span>
                启用地磅
              </div>
              <el-radio-group v-model="modifyParams.wagon">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">不启用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              style="margin-left: 10px;"
              v-if="dialogParams.typeModify === 'add'"
            >
              <div slot="label">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    创建此预约业务后，<br />会自动授权允许所选单位使用该业务。
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                创建后自动授权
              </div>
              <el-select
                v-model="modifyParams.dept"
                multiple
                placeholder="请选择自动授权部门"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in deptOptions"
                  :key="item.id"
                  :label="item.full_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 成品出厂 父业务 -->
          <div v-if="modifyParams.formType === 1">
            <el-form-item
              label="排队管理员"
              :rules="[{ required: true, message: '' }]"
            >
              <span v-for="(itemList, index) in listSuperAdmin" :key="index">
                <span
                  class="adminItem"
                  v-for="(item, indexItem) in itemList"
                  :key="indexItem"
                >
                  <User
                    :item="item"
                    :key="index + indexItem"
                    :type="index"
                    @removeTag="removeTag(index, item.id)"
                  />
                </span>
              </span>
              <div>
                <span
                  type="text"
                  @click="selectSuperAdmin"
                  style="color: #409EFF;"
                >
                  选择排队管理员
                </span>
              </div>

              <!-- <el-select
                v-model="modifyParams.queueManage"
                multiple
                placeholder="请选择排队管理员"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in queueManageOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          <span>取 消</span>
        </el-button>
        <el-button type="primary" @click="save" size="small">
          保 存
        </el-button>
      </span>
    </el-dialog>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      rowDataObj: {},
      params: {
        // 用于搜索的参数
        keyword: "", // 关键字搜索
        state: 0, // 状态
        pId: "" // 父业务
      },
      dialogParams: {
        // dialog参数，包括提示和编辑的dialog
        show: false, // 提醒 显示
        title: "", // 标题 “确认提醒” “操作成功”
        content: "", // dialog的内容
        type: "", // del、forbid、start
        showModify: false, // 编辑 显示
        typeModify: "" // edit、add
      },
      modifyParams: {
        // 添加、编辑参数
        parent: 0, // 父业务的下标  默认选择“无”，即一级业务
        id: 0, // id 0为新建，不为空为编辑
        name: "", // 业务名称
        remark: "", // 备注
        tpl: 1, // 选择模板 0：自定义；1：成品出厂；2卸货类（过地磅）
        dept: [], // 自动授权部门
        queueManage: [], // 排队管理员
        formType: -1, // 父业务模板类型、表单类型
        wagon: 1 // 是否启用地磅系统
      },
      maxSize: 0,
      tableData: [], // 表格数据
      parentSelectOption: [
        {
          name: "全部",
          id: ""
        }
      ], // 搜索父业务列表
      parentEditOption: [
        // 添加、编辑父业务列表
        {
          name: "无",
          id: "",
          tpl: -1
        }
      ],
      stateOption: ["全部", "正常", "已禁用"],
      queueManageOptions: [
        {
          value: "1",
          label: "排队管理员1"
        },
        {
          value: "2",
          label: "排队管理员2"
        }
      ],
      deptOptions: [], // 创建后自动授权
      listSuperAdmin: { org: [], group: [], user: [] }, // 人员选择器
      deptListObj: {
        title: "选择发送范围",
        // model: "user",
        model: "user_group",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      orgUrl: "",
      isCreatAddElDialog: true
    };
  },

  watch: {
    dialogParams(val) {
      if (!val.showModify) {
        setTimeout(() => {
          this.isCreatAddElDialog = false;
          this.$nextTick(() => {
            this.isCreatAddElDialog = true;
          });
        }, 200);
      }
    }
  },

  components: {
    pagi,
    viewTitle,
    Dept,
    User
  },

  mixins: [mixinTableLyout, mixinOrgUrl],

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  async mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    this.orgUrl = await this.mixinOrgUrlSet();
    this.getList();
    this.getParentList();
    this.getUnitList();
  },

  async activated() {},

  created() {},

  methods: {
    // 人员选择器
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      this.setSuperAdminUser();
    },

    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },

    selectSuperAdmin() {
      this.deptListObj.visible = true;
    },

    setSuperAdminUser() {
      this.listSuperAdmin = this.deptListObj.pluginResult.select;
    },

    removeTag(key, reItem) {
      let delIndex = 0;
      this.deptListObj.pluginResult.select[key].forEach((item, index) => {
        if (reItem == item.id) {
          delIndex = index;
        }
      });
      this.deptListObj.pluginResult.select[key].splice(delIndex, 1);
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let requestData = {};
      // pid 1.不传递时，获取全部数据; 2.传递不为空获取子级业务
      if (this.params.pId === "") {
        requestData = {
          keyword: this.params.keyword,
          state: this.params.state,
          page_size: this.pageSize,
          page: this.page
        };
      } else {
        requestData = {
          pid: this.params.pId,
          keyword: this.params.keyword,
          state: this.params.state,
          page_size: this.pageSize,
          page: this.page
        };
      }
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business",
        data: requestData
      });
      let obj = dataObj.data.data.data,
        dest = [];
      // 按照父级进行分组
      // for (let i = 0; i < obj.length; i++) {
      //   if (obj[i].pid === "") {
      //     dest.push(obj[i]);
      //     for (let j = 0; j < obj.length; j++) {
      //       if (obj[j].pid === obj[i].id) {
      //         dest.push(obj[j]);
      //       }
      //     }
      //   }
      // }
      console.log(dest.length, obj.length);
      // let newObj = JSON.parse(JSON.stringify(obj));
      // // 排除筛选时没有父级存在的情况
      // if (dest.length !== obj.length) {
      //   // dest = obj;
      //   for (let i = 0; i < obj.length; i++) {
      //     for (let j = 0; j < dest.length; j++) {
      //       if (dest[j].id === obj[i].id) {
      //         newObj.splice(i, 1);
      //       }
      //     }
      //   }
      //   newObj.forEach(item => {
      //     dest.push(item);
      //   });
      // }

      this.tableData = obj;
      this.count = dataObj.data.data.total;
    },

    // 获取列表
    async getParentList() {
      this.parentSelectOption = [
        {
          name: "全部",
          id: ""
        }
      ];
      this.parentEditOption = [
        {
          name: "无",
          id: "",
          tpl: -1
        }
      ];
      await this.$common
        .http({
          url: "/api/queue/admin/query_business",
          data: {
            pid: "",
            keyword: "",
            state: 0
          }
        })
        .then(res => {
          console.log(res.data.data);
          let obj = res.data.data;
          for (let i = 0; i < obj.length; i++) {
            // 筛选父列表
            this.parentSelectOption.push({
              name: obj[i].name,
              id: obj[i].id
            });
            // 编辑父列表
            this.parentEditOption.push({
              name: obj[i].name,
              id: obj[i].id,
              tpl: obj[i].type
            });
          }
        });
    },

    // 获取单位列表
    async getUnitList() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit",
          data: {
            state: 0,
            keyword: "",
            class_id: "",
            page_size: ""
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.deptOptions = res.data.data;
        });
    },

    // 修改状态
    changeState(val) {
      this.page = 1;
      this.params.state = val;
      this.getList();
    },

    // 切换筛选父业务
    changeSelectPID(val) {
      this.page = 1;
      this.params.pId = val;
      this.getList();
    },

    // 切换父业务
    changeEditParent(val) {
      this.modifyParams.formType = this.parentEditOption[val].tpl;
      // 重置表单数据
      this.modifyParams.dept = "";
      this.modifyParams.name = "";
      this.modifyParams.queueManage = "";
      this.modifyParams.remark = "";
      this.modifyParams.tpl = 1;
      this.modifyParams.wagon = "";
      this.deptListObj.pluginResult = {
        select: { org: [], group: [], user: [] }
      };
      this.listSuperAdmin = { org: [], group: [], user: [] };
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/appoint/timeTplList/detail",
        query: {
          type: "edit"
        }
      });
    },

    // 查看详情
    modifyTpl(row, tag) {
      console.log(row, tag);
      this.dialogParams.showModify = true;
      this.dialogParams.typeModify = tag;

      if (tag === "edit") {
        if (row.pid === "") {
          this.modifyParams.dept = row.auto_auth_units;
          this.modifyParams.formType = -1;
          this.modifyParams.id = row.id;
          this.modifyParams.name = row.name;
          this.modifyParams.parent = 0;
          this.modifyParams.queueManage = row.user_list;
          this.modifyParams.remark = row.note;
          this.modifyParams.tpl = row.type;
          this.modifyParams.wagon = row.enable_loadometer;
        } else {
          this.modifyParams.dept = row.auto_auth_units;
          this.modifyParams.formType = row.type;
          this.modifyParams.id = row.id;
          this.modifyParams.name = row.name;
          for (let i = 0; i < this.parentEditOption.length; i++) {
            if (this.parentEditOption[i].id === row.pid) {
              this.modifyParams.parent = i;
            }
          }
          this.modifyParams.queueManage = row.user_list;
          this.modifyParams.remark = row.note;
          this.modifyParams.tpl = row.type;
          this.modifyParams.wagon = row.enable_loadometer;
          // 人员选择器
          this.$common
            .http({
              url: this.orgUrl.getInitData,
              data: {
                depts: "",
                users: row.user_list,
                tags: row.tag_list
              }
            })
            .then(res1 => {
              console.log(res1);
              let obj1 = res1.data.data;
              this.listSuperAdmin = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
              this.deptListObj.pluginResult.select = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
            });
        }
      }
    },

    // 删除/禁用启用
    delOrEnable(row, tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
      this.rowDataObj = row;
      if (tag === "del") {
        this.dialogParams.content = `确认要删除“<span class="color67">${this.rowDataObj.name}</span>”业务吗？<br />
        <span class="color67">删除后不可恢复！</span>`;
      } else if (tag === "forbid") {
        this.dialogParams.content = `确认要禁用“<span class="color67">${this.rowDataObj.name}</span>”业务吗？`;
      } else if (tag === "start") {
        this.dialogParams.content = `确认要启用“<span class="color67">${this.rowDataObj.name}</span>”业务吗？`;
      }
    },

    // 确认删除/禁用启用
    confirm() {
      this.dialogParams.show = false;
      let url = "";
      if (this.dialogParams.type === "del") {
        url = "/api/queue/admin/delete_business";
      } else if (
        this.dialogParams.type === "forbid" ||
        this.dialogParams.type === "start"
      ) {
        url = "/api/queue/admin/enable_business";
      }
      this.$common
        .http({
          url: url,
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res);
          // this.dialogParams.content = `已成功删除“<span class="color67">${this.rowDataObj.name}</span>”业务。`;
          if (this.dialogParams.type === "del") {
            this.$common.pcToastSuccess(
              `已成功删除“${this.rowDataObj.name}”业务。`
            );
          } else if (this.dialogParams.type === "forbid") {
            this.$common.pcToastSuccess(
              `已成功禁用“${this.rowDataObj.name}”业务。`
            );
          } else if (this.dialogParams.type === "start") {
            this.$common.pcToastSuccess(
              `已成功启用“${this.rowDataObj.name}”业务。`
            );
          }
          // this.dialogParams.show = true;
          // this.dialogParams.title = "操作成功";
          this.getList();
          // setTimeout(() => {
          //   this.dialogParams.show = false;
          // }, 1500);
        });
    },

    // 保存表单
    // formType === -1  一级父业务  formType === 0 自定义业务 formType === 1 成品出厂
    save() {
      // 人员选择器
      let user_list = [];
      this.listSuperAdmin.user.forEach(item => {
        user_list.push(item.id);
      });
      let tag_list = [];
      this.listSuperAdmin.group.forEach(item => {
        tag_list.push(item.id);
      });
      if (this.modifyParams.name.trim() === "") {
        this.$common.pcToastFail("业务名称不能为空");
        return false;
      }
      if (this.modifyParams.remark.trim().length > 50) {
        this.$common.pcToastFail("备注不能超过50个字符");
        return false;
      }
      if (this.modifyParams.formType === 1) {
        if (user_list.length === 0 && tag_list.length == 0) {
          this.$common.pcToastFail("请选择排队管理员");
          return false;
        }
      }

      // 人员选择器
      let userList = [];
      this.listSuperAdmin.user.forEach(item => {
        userList.push(item.id);
      });

      let data = {};
      // 一级父业务
      if (this.modifyParams.formType === -1) {
        data = {
          id: this.modifyParams.id,
          name: this.modifyParams.name,
          type: this.modifyParams.tpl,
          pid: "",
          user_list: "",
          auto_auth_units: JSON.stringify(this.modifyParams.dept),
          note: this.modifyParams.remark,
          enable_loadometer: this.modifyParams.wagon
        };
      } else if (
        this.modifyParams.formType === 1 ||
        this.modifyParams.formType === 0 ||
        this.modifyParams.formType === 2
      ) {
        data = {
          id: this.modifyParams.id,
          name: this.modifyParams.name,
          type: this.modifyParams.formType,
          pid: this.parentEditOption[this.modifyParams.parent].id,
          user_list: "",
          auto_auth_units: "",
          note: this.modifyParams.remark,
          enable_loadometer: ""
        };
      }
      if (this.modifyParams.formType === 1) {
        data.user_list = JSON.stringify(userList);
        data.tag_list = JSON.stringify(tag_list);
      }
      console.log(data);
      this.$common
        .http({
          url: "/api/queue/admin/save_business",
          data: data
        })
        .then(res => {
          console.log(res);
          this.dialogParams.showModify = false;
          if (res.data.data) {
            if (this.dialogParams.typeModify === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          this.getParentList();
          // 重置表单
          for (let key in this.modifyParams) {
            this.modifyParams[key] = "";
          }
          this.modifyParams.dept = [];
          this.modifyParams.formType = -1;
          this.modifyParams.id = 0;
          this.modifyParams.parent = 0;
          this.modifyParams.queueManage = [];
          this.modifyParams.tpl = 1;
          this.modifyParams.wagon = 1;
        });
    },

    cancel() {
      this.dialogParams.showModify = false;
      for (let key in this.modifyParams) {
        this.modifyParams[key] = "";
      }
      this.modifyParams.dept = [];
      this.modifyParams.formType = -1;
      this.modifyParams.id = 0;
      this.modifyParams.parent = 0;
      this.modifyParams.queueManage = [];
      this.modifyParams.tpl = 1;
      this.modifyParams.wagon = 1;
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 25; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 260; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.appointSeviceDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
  .adminItem {
    margin-right: 10px;
  }
}
</style>
